import { useEffect, useState } from "react";
import VenueTable from "../../components/KIYG25/VenueTableForMedical";
import Breadcrumb from "../../components/common/Breadcrumb";

export default function KIYGMedical() {
  const [venues, setVenues] = useState();

  useEffect(() => {
    async function fetchData() {
      const venuesResponse = await fetch("data/kiyg25-medical-hindi.json");
      const venues = await venuesResponse.json();
      setVenues(venues);
    }
    fetchData();
  }, []);

  return (
    <div style={{ overflow: "auto" }}>
      <Breadcrumb
        pageName={KIYGMedical}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      {venues && <VenueTable venues={venues} />}
    </div>
  );
}
